export default __webpack_public_path__ + "static/media/yelpOne.b060cd4f.png";